import { VFC } from "react";
// Utils
import { FIELD_VIEW } from "constants/Routes";
import { useGetCurrentBusinessUnit, useStateSpecies } from "hooks";
// Components
import { AnimalsSummaryCard } from "components/MyLivestock";
import { FieldsQuery } from "generated/graphql";
import { removeNothings } from "helpers/general";

interface FieldItemProps {
  field: NonNullable<FieldsQuery["fields"]>[number];
  history: RouteHistory;
}

export const FieldItem: VFC<FieldItemProps> = ({ field }) => {
  const { list: speciesList } = useStateSpecies();

  const { weightUnits } = useGetCurrentBusinessUnit();

  const { isOrganic, isYard, location, name, sizeUnit, fieldDensity, avgAge, avgDlwg, avgEstimatedWeight } = {
    ...field,
  };

  const fieldDetailsPath = `${FIELD_VIEW}/${field?.id}`;

  const summaryMetrics = removeNothings(field?.summaryMetrics || []);

  const breedSexData = summaryMetrics?.map((item) => {
    const summarySpecies = speciesList?.find((species) => +species.id === item?.animalTypeId);

    return {
      breedCode: item?.breedrCode || "",
      speciesColour: summarySpecies?.colour,
      speciesIconUrl: summarySpecies?.image || undefined,
      totalAnimals: item?.animalsCount || 0,
      totalFemale: item?.femaleCount || 0,
      totalMale: item?.maleCount || 0,
    };
  });

  const fieldKeyData = [
    {
      label: `Density/${sizeUnit}`,
      unit: `per ${sizeUnit}`,
      value: +fieldDensity ? fieldDensity : null,
    },
    { label: "Avg. DLWG", unit: weightUnits, value: avgDlwg },
    { label: "Avg. estimated weight", unit: weightUnits, value: avgEstimatedWeight },
    {
      label: "Avg. age",
      unit: "months",
      value: avgAge,
    },
  ];

  return (
    <AnimalsSummaryCard
      breedSummaryData={breedSexData}
      isOrganic={isOrganic}
      isYard={isYard}
      keyValueData={fieldKeyData}
      onClickUrl={fieldDetailsPath}
      title={name || ""}
      summaryMetrics={summaryMetrics}
      location={location}
      showIcons
    />
  );
};
